import { Typography, Grid } from "@mui/material";
import React from "react";
import ProjectCard from "./ProjectCard";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";

 
import "./Project.css";

export default function Project() {
  const project = [
    {
      name: "Sorting Visualizer",
      description: `This sorting algorithm visualizer for the flexible array size and
    with the flexible speed for a better understanding of the
    algorithm.`,
      live: "https://sorting-visualizer-by-vyas.netlify.app/",
      github: "https://github.com/MrVyas2511/Sorting_Visulizer",
      techstack: [
        "https://img.icons8.com/color/28/000000/html-5--v1.png",
        "https://img.icons8.com/color/28/000000/css3.png",
        "https://img.icons8.com/ios-filled/28/000fff/javascript.png",
      ],
    },
    {
      name: "Say-Hii",
      description: `Say-Hii is a social media app like Twitter In which users can register/login, can post twits, and also
      can like and comment on other posts.`,
      live: "https://say-hii.netlify.app/",
      github: "https://github.com/MrVyas2511/social-media-app",
      techstack: [
        "https://img.icons8.com/officel/28/000000/react.png",
        "https://img.icons8.com/color/28/000000/nodejs.png",
        "https://img.icons8.com/color/28/000000/graphql.png",
        "https://img.icons8.com/color/28/000000/mongodb.png",
      ],
    },
    {
      name: "Crypto web app",
      description: `CryptoAPP is a web application to monitor the crypto markets and is updated with the latest news.`,
      live: "https://crypto-webapp.netlify.app/",
      github: "https://github.com/MrVyas2511/cryptoapp",
      techstack: [
        "https://img.icons8.com/officel/28/000000/react.png",
        "https://img.icons8.com/color/28/000000/redux.png",
        "https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg",
      ],
    },
  ];
  const items = project.map((e) => (
    <ProjectCard
      name={e.name}
      description={e.description}
      live={e.live}
      github={e.github}
      techstack={e.techstack}
      img={e.img}></ProjectCard>
  ));
  return (
    <div align="center" className="project-section">
      <Typography
        variant="h4"
        color={"#fff"}
        align="center"
        sx={{ margin: "50px" }}>
        My Projects
      </Typography>

      <AliceCarousel
        mouseTracking
        autoPlay
        infinite
        autoPlayInterval={1000}
        disableButtonsControls
        items={items}
        disableSlideInfo={false}
        animationDuration={1500}
      />
    </div>
  );
}
